<template>
  <div class="chatArea">
		<iframe ref="iframeRef" class="ca_iframe" allow="camera *; microphone *;display-capture;midi;encrypted-media;" :src="src"></iframe>
  </div>
</template>

<script>

export default {

  data() {
    return {
      userId: this.$route.query.userid,
      org: this.$route.query.org,
      oid: this.$route.query.oid,
			type:this.$route.query.type,
			src:"https://cloud.cocorobo.hk/aigpt/#/poc?muti_agent_id=798c3511-6b32-11ef-8ce0-12e77c4cb76b&isPbl=false&session_id=merenduihua444"
    };
  },
  methods: {

  },
  mounted() {
		if (this.type == 1) {
			// 2.1
			console.log("2.1课程")
      this.src = `https://cloud.cocorobo.hk/aigpt/#/poc?muti_agent_id=798c3511-6b32-11ef-8ce0-12e77c4cb76b&isPbl=false&session_id=${this.userId}-21`;
			console.log("5")
    } else if (this.type == 2) {
			//2.2
			console.log("2.2课程")
      this.src = `https://cloud.cocorobo.hk/aigpt/#/poc?muti_agent_id=a9883cc4-6c3d-11ef-8ce0-12e77c4cb76b&isPbl=false&session_id=${this.userId}-22`;
			console.log(3)
    }
  }
};
</script>

<style scoped>
.chatArea{
	width: 100vw;
	height: 100vh;
	overflow: hidden;
}

.ca_iframe{
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/pocAiClassroom/pocClass.vue